export const COMPLIANCE_CUSTOMERS_LIST_PAGE_SIZE = 15;
